import { readDeviceLanguage } from "$/lib/language-preference"
import translationQueries from "$/lib/queries/translation-queries"
import { userQueryOptions } from "$/lib/queries/user-queries"
import { Translator } from "@repo/common"
import { QueryClient } from "@tanstack/react-query"
import { createTranslator } from "use-intl"

/**
 * Route loaders run outside the IntlProvider, so toasts shown from them build
 * the same translator from the cached user and dictionary.
 */
export async function loadTranslator(
  queryClient: QueryClient,
): Promise<Translator> {
  const user = queryClient.getQueryData(userQueryOptions.queryKey)
  const language = user?.language ?? readDeviceLanguage()
  const dictionary = await queryClient.ensureQueryData(
    translationQueries.dictionary(language),
  )
  const translate = createTranslator({
    locale: language,
    messages: dictionary.messages,
  })

  return (key, values) => translate(key, values)
}
